/**
 * Extracts initials from a name for avatar display.
 * - Single word: takes first 2 chars (e.g., "Madonna" → "MA")
 * - Multiple words: takes first letter of first two words (e.g., "John Doe" → "JD")
 * - Empty/null: returns "?"
 */
export default function avatarInitials(
  name: string | null | undefined
): string {
  if (!name) return '?';

  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    // Single word: take first 2 chars
    const first = parts[0];
    if (!first || first.length === 0) return '?';
    return first.slice(0, 2).toUpperCase();
  }

  // Multiple words: take first letter of first two words
  const first = parts[0];
  const second = parts[1];
  if (!first || !second || first.length === 0 || second.length === 0) {
    return '?';
  }
  return (first.charAt(0) + second.charAt(0)).toUpperCase();
}
